import React from "react";
import { format } from "date-fns";

/*
**  DatePicker - single date with time selection
**  Uses native HTML5 date and time inputs - no MUI lab required
**  Props: date (Date), setDate (function)
*/

function toDateValue(date) {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  return format(d, "yyyy-MM-dd");
}

function toTimeValue(date) {
  if (!date) return "09:00";
  const d = date instanceof Date ? date : new Date(date);
  return format(d, "HH:mm");
}

export const DatePicker = ({ date, setDate }) => {
  const dateValue = toDateValue(date);
  const timeValue = toTimeValue(date);
  const today = format(new Date(), "yyyy-MM-dd");

  const handleDateChange = (e) => {
    const newDateStr = e.target.value;
    if (!newDateStr) return;
    const current = date ? new Date(date) : new Date();
    const [hours, minutes] = [current.getHours(), current.getMinutes()];
    const combined = new Date(newDateStr + "T" + format(current, "HH:mm"));
    combined.setHours(hours, minutes, 0, 0);
    setDate(combined);
  };

  const handleTimeChange = (e) => {
    const newTimeStr = e.target.value;
    if (!newTimeStr) return;
    const current = date ? new Date(date) : new Date();
    const baseDate = format(current, "yyyy-MM-dd");
    const combined = new Date(baseDate + "T" + newTimeStr);
    setDate(combined);
  };

  const inputStyle = {
    width: "-webkit-fill-available",
    height: 30,
    padding: "4px 8px",
    fontSize: 14,
    border: "1px solid rgba(0,0,0,0.23)",
    borderRadius: 4,
    outline: "none",
  };

  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center", width: "100%" }}>
      <input
        type="date"
        value={dateValue}
        onChange={handleDateChange}
        min={today}
        style={inputStyle}
      />
      <input
        type="time"
        value={timeValue}
        onChange={handleTimeChange}
        style={inputStyle}
      />
    </div>
  );
};
